<template>
  <rect width="16" height="16" rx="8" fill="#3769D6" />
  <path
    d="M5 8L7 10L11 6"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
